import React, { useState } from 'react';

export function DailyShareCount() {
  const [dailyData,] = useState([]);

  return (
    <>
      <div className="">
        <h1 className="text-2xl font-bold mb-6">Daily Share Count Report</h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-gray-500 text-sm">Today's Total Shares</h3>
            <p className="text-2xl font-bold">67</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-gray-500 text-sm">Pending Distribution</h3>
            <p className="text-2xl font-bold text-yellow-600">23</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-gray-500 text-sm">Distributed</h3>
            <p className="text-2xl font-bold text-green-600">44</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Distribution Details</h2>
            <div className="flex space-x-2">
              <input type="date" className="border rounded p-2" />
              <select className="border rounded p-2">
                <option value="all">All Status</option>
                <option value="pending">Pending</option>
                <option value="distributed">Distributed</option>
              </select>
              <button className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
                Download Report
              </button>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Share ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Customer</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Animal Type</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Share Number</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Weight</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Distribution Time</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {dailyData.map((share, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4">{share.id}</td>
                    <td className="px-6 py-4">{share.customerName}</td>
                    <td className="px-6 py-4">{share.animalType}</td>
                    <td className="px-6 py-4">{share.shareNumber}</td>
                    <td className="px-6 py-4">{share.weight} kg</td>
                    <td className="px-6 py-4">{share.distributionTime}</td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-1 rounded-full text-xs ${share.status === 'distributed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                        }`}>
                        {share.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}